import { Badge, IconButton, Tooltip } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { useInboxDock } from './InboxDock';

/**
 * The inbox's entry point, now that it isn't a page in the menu.
 *
 * The count is the team-wide number of conversations waiting on a reply — not a
 * personal unread — so everyone sees the same number and anyone can clear it.
 * It comes from the provider rather than its own query, so this badge, the
 * rail's and the panel header's are the same value by construction.
 */
export function InboxAppBarButton() {
  const dock = useInboxDock();

  if (!dock) return null;

  return (
    <Tooltip title={dock.open ? 'Hide the inbox (⌘/)' : 'Show the inbox (⌘/)'}>
      <IconButton
        color="inherit"
        size="small"
        onClick={dock.toggle}
        aria-label="Toggle the inbox"
        sx={{ mr: 0.5 }}
      >
        <Badge
          badgeContent={dock.unrepliedCount}
          color="warning"
          overlap="circular"
          sx={{ '& .MuiBadge-badge': { fontSize: 10, height: 16, minWidth: 16, padding: '0 4px' } }}
        >
          <InboxIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
